import { isTag } from 'anodum';
import { LINK_TAG } from '../constants/editable-elements';
import getLinkConfig from '../../link-editing/accessors/get-link-config';
import constants from '../../link-editing/constants';

const attributesToRemove = ['href', 'rel', 'target', 'download'];

const handleLinkElement = (element) => {
  if (!isTag(element, LINK_TAG)) {
    return element;
  }

  let hasLinkConfig = element.hasAttribute(constants.common.LINK_CONFIG_ATTRIBUTE);

  // if config is not valid JSON, we have to remove it and set default
  // because of publish issue https://github.com/yola/production/issues/16560
  if (hasLinkConfig) {
    try {
      JSON.parse(element.getAttribute(constants.common.LINK_CONFIG_ATTRIBUTE));
    } catch (error) {
      element.removeAttribute(constants.common.LINK_CONFIG_ATTRIBUTE);
      hasLinkConfig = false;
    }
  }

  if (!hasLinkConfig) {
    const config = getLinkConfig(element);
    attributesToRemove.forEach((attribute) => element.removeAttribute(attribute));
    element.setAttribute(constants.common.LINK_CONFIG_ATTRIBUTE, JSON.stringify(config));
  }

  return element;
};

export default handleLinkElement;
